// Central business configuration — single source of truth.
// Verified information for Mobile Specialist, Sector 3, Rohini, Delhi.

export const business = {
  businessName: "Mobile Specialist",
  businessType: "Mobile Phone Repair Shop",

  // Phone and WhatsApp are configured separately on purpose.
  phone: "+918527573797",
  phoneDisplay: "+91 85275 73797",
  whatsapp: "918527573797", // digits only, country code included, no '+'

  address: "Shop Number 3, Pocket E-18/46, Opposite Remal Public School",
  locality: "Sector 3, Rohini",
  city: "Delhi",
  postalCode: "110085",
  country: "India",

  googleRating: 4.9,
  googleReviewCount: 323,

  googleProfileUrl:
    "https://www.google.com/search?client=ms-android-samsung-ss&sca_esv=ab02dd2696e7e4b9&cs=1&sxsrf=ACQVn08BvPHOJnS1sHixz4HrAy-Fxuz89Q:1711480640178&q=Mobile+Specialist&ludocid=5472698347802263419",
  googleMapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Mobile+Specialist+Shop+3+Pocket+E-18%2F46+Sector+3+Rohini+Delhi+110085",
  googleDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Mobile+Specialist+Shop+3+Pocket+E-18%2F46+Sector+3+Rohini+Delhi+110085",
  instagramUrl: "https://www.instagram.com/mobilespecialistrohini",
  youtubeUrl: "https://www.youtube.com/@MobileSpecialistRohinisector3",

  // Google Business hours applied to every day unless the owner updates them.
  openingHours: [
    { day: "Monday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Tuesday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Wednesday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Thursday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Friday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Saturday", open: "11:00 AM", close: "9:00 PM" },
    { day: "Sunday", open: "11:00 AM", close: "9:00 PM" },
  ],
  hoursSummary: "Open every day · 11:00 AM – 9:00 PM",

  services: [
    "Battery replacement",
    "Screen repair",
    "Screen replacement",
    "Camera repair",
    "Charge port repair",
    "Button repair",
    "Power button repair",
    "Speaker repair",
    "Microphone repair",
    "Software services",
    "Software problem diagnosis",
    "Data backup & recovery",
    "Diagnostic scan",
    "Water-damage repair",
    "Apple repair services",
    "Tablet repair",
  ],
};

export const fullAddress = `${business.address}, ${business.locality}, ${business.city} - ${business.postalCode}, ${business.country}`;
